module.exports = __webpack_public_path__ + "img/kaixinle.4776f19f.gif";